function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-532 -16)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#4a4a4a",
  strokeWidth: ".5",
  width: "566",
  height: "48",
  rx: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543.033 24l4.548-4.549a1.43 1.43 0 000-2.021l-1.01-1.011a1.43 1.43 0 00-2.022 0L540 20.967l-4.549-4.548a1.43 1.43 0 00-2.021 0l-1.011 1.01a1.43 1.43 0 000 2.022L536.967 24l-4.548 4.549a1.43 1.43 0 000 2.021l1.01 1.011a1.43 1.43 0 002.022 0L540 27.033l4.549 4.548a1.43 1.43 0 002.021 0l1.011-1.01a1.43 1.43 0 000-2.022L543.033 24z",
  fill: "currentColor"
}))));